/**
 * PopupSection - Reusable section block for popup content
 * 
 * Props:
 * - title: Section header text
 * - children: Content (typically a paragraph or list)
 * - isLast: If true, removes bottom margin (default: false)
 * - titleStyle: Override title styles
 * - contentStyle: Override content/paragraph styles
 */
function PopupSection({ 
  title, 
  children, 
  isLast = false,
  titleStyle = {},
  contentStyle = {}
}) {
  const defaultTitleStyle = {
    margin: "0 0 8px 0",
    fontSize: "16px",
    fontWeight: "600",
    color: "#012127",
  };

  const defaultContentStyle = {
    margin: 0,
    fontSize: "14px",
    color: "#40464B",
    lineHeight: "1.6",
  };

  return (
    <div style={{ marginBottom: isLast ? 0 : "20px" }}>
      {title && (
        <h3 style={{ ...defaultTitleStyle, ...titleStyle }}>
          {title}
        </h3>
      )}
      <div style={{ ...defaultContentStyle, ...contentStyle }}>
        {children}
      </div>
    </div>
  );
}

export default PopupSection;

